import { Footer, FooterProps } from '@everlywell/consumer-ui';
import { Box } from '@everlywell/ui-kit';
import { Link } from 'gatsby';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import {
  handleIterableSubscription,
  ensureAbsoluteUrl,
} from '../../utils/consts/helpers';
import useFooter from '../../utils/hooks/useFooter';
import { FooterTracking } from './FooterV2.tracking';

export type FooterV2Props = {};

const AdditionalContent = () => (
  <Box
    as="a"
    href="https://legitscript.com"
    target="_blank"
    rel="noreferrer"
    title="Verify LegitScript Approval"
    maxWidth={['56px', null, null, '80px']}
  >
    <img
      src="https://static.legitscript.com/seals/4099199.png"
      alt="LegitScript approved"
      style={{
        width: '100%',
        maxWidth: '80px',
        height: 'auto',
      }}
    />
  </Box>
);

export default function FooterV2(props: FooterV2Props) {
  const { footer } = useFooter();
  const { inView, ref } = useInView({
    triggerOnce: true,
  });

  const socialLinks = footer?.listOfSocialMedia?.map((socialLink) => ({
    name: socialLink?.name,
    href: socialLink?.link?.url,
  }));
  const complianceLinks = footer?.policyLinks?.map((policyLink) => ({
    label: policyLink?.label ?? '',
    href: ensureAbsoluteUrl(policyLink?.url) ?? '',
  }));

  const navigationSections = footer?.mainNavigation?.map((section) => ({
    title: section?.groupLabel ?? '',
    links:
      section?.menuLinks?.map((menuLink) => ({
        href: ensureAbsoluteUrl(menuLink?.url) ?? '',
        label: menuLink?.label ?? '',
      })) ?? [],
  }));

  const disclaimer = footer?.disclaimer?.childMarkdownRemark?.html ?? '';

  useEffect(() => {
    if (inView) {
      FooterTracking.trackView();
    }
  }, [inView]);

  return (
    <Footer
      socialMediaLabel={footer?.socialMediaLabel ?? ''}
      newsletterLabel={footer?.newsletterLabel ?? ''}
      socialLinks={(socialLinks ?? []) as FooterProps['socialLinks']}
      complianceLinks={complianceLinks ?? []}
      disclaimer={disclaimer}
      navigationSections={navigationSections}
      additionalContent={<AdditionalContent />}
      linkComponent={Link}
      onEmailSubmit={handleIterableSubscription}
      onLinkClick={FooterTracking.trackLinkClick}
      onSocialMediaClick={FooterTracking.trackSocialMediaClick}
      ref={ref}
    />
  );
}
